const FEATURE_LABELS = {
  powerfulDashboard: "Powerful Dashboard",
  deleteShortUrls: "Delete Short URLs",
  customizeUrls: "Customize URLs",
  changeDestination: "Change Destination",
  multipleShortUrls: "Multiple Short URLs",
  noAds: "No Ads",
  socialShare: "Social Sharing",
  httpRedirectCode: "HTTP Redirect Codes",
  passwordProtection: "Password Protection",
  urlExpiration: "URL Expiration",
  addTitleLabel: "Add Title & Label",
  urlCloaking: "URL Cloaking",

  // QR Codes
  instantQr: "Instant QR",
  colorOptions: "Color Options",
  customLogo: "Custom Logo",
  styleOptions: "Style Options",
  customFrames: "Custom Frames",
  brandingTemplates: "Branding Templates",
  downloadFormat: "Download Formats",

  // Domains
  brandedDomains: "Branded Domains",
  landingPage: "Custom Landing Page",
  redirect404: "404 Redirect",
  freeSSL: "Free SSL",
  customSSL: "Custom SSL",

  // Analytics
  dashboard: "Analytics Dashboard",
  timelineChart: "Timeline Chart",
  advancedCharts: "Advanced Charts",
  uniqueRepeatedClicks: "Unique vs Repeated Clicks",
  geoAnalytics: "Geographic Analytics",
  timezoneBrowser: "Timezone & Browser",
  filtering: "Analytics Filtering",
  publicReports: "Public Reports",
  downloadableReports: "Downloadable Reports",

  // Campaigns
  tagUrls: "Tag URLs",
  bulkImport: "Bulk Import",
  exportAnalytics: "Export Analytics",
  totalTagsAllowed: "Total Tags Allowed",
  maxUrlsPerTag: "Max URLs per Tag",
  utmBuilder: "UTM Builder",
  retargeting: "Retargeting",
  aBTesting: "A/B Testing",
  mobileTargeting: "Mobile Targeting",
  geoTargeting: "Geo Targeting",
  parameterForwarding: "Parameter Forwarding",

  // CSV
  bulkUpdate: "Bulk Update",
  exportAll: "Export All",

  // API
  access: "API Access",
  keys: "API Keys",
  rateLimit: "API Rate Limit",

  // Security
  twoFA: "Two-Factor Authentication",
  multiSession: "Multiple Sessions",
  teammates: "Team Members",
  sso: "Single Sign-On",

  // Support
  gdpr: "GDPR Compliance",
  helpCenter: "Help Center",
  premiumSupport: "Premium Support",
  managedService: "Managed Service",
  onboarding: "Onboarding Assistance",
  uptimeSLA: "Uptime SLA",
  dataResidence: "Data Residence",

  // Extras
  whiteLabel: "White Label",
  successRep: "Dedicated Success Manager",
  onDemandScaling: "On-Demand Scaling",
};

export default FEATURE_LABELS;
